export const routes = {
  video_tutorials: "/video-tutorials",
  articles: "/articles"
};